// extracted by mini-css-extract-plugin
export var iconContainer = "_ff-0";
export var metricCardsContainer = "_ff-1";